import styled from 'styled-components'
import { Devices, Spacings } from '@styles'
import ButtonV2 from './Button'


const getV2Variant = (type) => {
	if (type === 'secondary') return 'outline'
	if (type === 'tertiary') return 'ghost'
	return 'solid'
}

const getV2Color = (variant) => {
	if (variant === 'destructive') return 'danger'
	if (variant === 'success') return 'success'
	return 'primary'
}

const MobileButton = styled.button`
	position: ${({ $notFixed }) => ($notFixed ? 'initial' : 'fixed')};
	bottom: ${({ $bottom }) => $bottom ?? '2.5rem'};
	right: ${({ $right }) => $right ?? '1rem'};
	margin: ${({ $notFixed, $margin }) => ($notFixed ? $margin : 0)};
	z-index: 1;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: ${Spacings.SPACING_2B};
	border: none;
	border-radius: ${({ theme }) => theme.radius.full};
	background: ${({ theme, disabled }) => (disabled ? theme.colors.text.disabled : theme.colors.brand.primary)};
	color: ${({ theme }) => theme.colors.text.inverse};
	box-shadow: ${({ theme }) => theme.shadows.md};
	cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
	transition: background 0.15s ease-in, box-shadow 0.15s ease-in;

	&:hover:not(:disabled) {
		background: ${({ theme }) => theme.colors.brand.hover};
		box-shadow: ${({ theme }) => theme.shadows.lg};
	}

	@media ${Devices.tablet} {
		display: none;
	}
`

const DesktopButton = styled(ButtonV2)`
	display: none;
	margin: ${({ $margin }) => $margin || 0};

	@media ${Devices.tablet} {
		display: inline-flex;
	}
`

const FloatingButton = ({
	desktopLabel,
	mobileLabel,
	children,
	// v1 layout props
	notFixed,
	margin,
	bottom,
	right,
	// v1 Button props (mapped to v2 Button, never passed to the DOM)
	type,
	variant,
	small,
	xs,
	isBorder,
	uppercase,
	...props
}) => {
	return (
		<>
			<MobileButton type='button' $notFixed={notFixed} $margin={margin} $bottom={bottom} $right={right} {...props}>
				{mobileLabel}
			</MobileButton>
			<DesktopButton
				type='button'
				variant={getV2Variant(type)}
				color={getV2Color(variant)}
				size={xs ? 'small' : 'base'}
				$margin={margin}
				{...props}
			>
				{desktopLabel}
			</DesktopButton>
			{children}
		</>
	)
}

export default FloatingButton
